import React, {useState} from 'react';
import './TodayRequest.css';

function TodayRequest() {

    const [Debt,SetDebt] = useState(false);
    const array3 = [
        {
            name : "علی ایرانی",
            UserCeiling : "123,125,2,555",
            UserBalance : "123,125,2,555",
        },
        {
            name : "علی ایرانی",
            UserCeiling : "123,125,2,555",
            UserBalance : "123,125,2,555",
        },
        {
            name : "علی ایرانی",
            UserCeiling : "123,125,2,555",
            UserBalance : "123,125,2,555",
        },
        {
            name : "علی ایرانی",
            UserCeiling : "123,125,2,555",
            UserBalance : "123,125,2,555",
        },
        {
            name : "علی ایرانی",
            UserCeiling : "123,125,2,555",
            UserBalance : "123,125,2,555",
        },
        {
            name : "علی ایرانی",
            UserCeiling : "123,125,2,555",
            UserBalance : "123,125,2,555",
        },
        {
            name : "علی ایرانی",
            UserCeiling : "123,125,2,555",
            UserBalance : "123,125,2,555",
        },
        {
            name : "علی ایرانی",
            UserCeiling : "123,125,2,555",
            UserBalance : "123,125,2,555",
        }
    ];

    const arrayList = ["نام کاربر","سقف کاربر","مانده کاربر"];

    function ShowDebt() {
        SetDebt(!Debt);
    }

    function isCouple(e) {
        if (e % 2 === 0){
            return false
        }else return true
    }


    return (
        <div className="TodayRequest">
            <div className="TodayRequestTitle">
                <h3>درخواست های امروز</h3>
            </div>
            <div className="d-flex justify-content-between TodayRequestCount align-items-center">
                <h3 className="TodayRequestCountTitle">تعداد درخواست های سفارش مشتریان</h3>
                <div className="d-flex">
                    <h3 className="TodayRequestCountData">15</h3>
                    <h3 className="TodayRequestCountText">نفر</h3>
                </div>
            </div>
            <div className="d-flex justify-content-between TodayRequestDebt align-items-center">
                <h3 className="TodayRequestCountTitle">مجموع بدهکاری مشتریان</h3>
                <div className="d-flex">
                    <h3 className="TodayRequestDebtData">52,852,552,000</h3>
                    <h3 className="TodayRequestCountText">ریال</h3>
                </div>
            </div>
            <div className="d-flex justify-content-end align-items-center detail">
                <div className="d-flex align-items-center">
                    <i
                        className={`fas downDebt ${Debt ? "fa-chevron-up" : "fa-chevron-down"}`}
                        onClick={ShowDebt}
                    />
                    <h3 className="detailTitle">جزئیات</h3>
                </div>
            </div>
            <div
                className={`flex-column animate d-flex`}
                style={{height:`${Debt ? "271px" : "0px"}`}}
            >
                <div className="d-flex justify-content-around FirstRowTable">
                    {arrayList.map((x,i)=>(
                        <div className="d-flex TitleTable align-items-center" key={i}>
                            <h4>{x}</h4>
                            <div className="d-flex flex-column mr-2">
                                <i className="fas fa-caret-up UpDownIcon"/>
                                <i className="fas fa-caret-down UpDownIcon"/>
                            </div>
                        </div>
                    ))}
                </div>
                {array3.map((x,i)=>(
                    <div
                        className={`d-flex justify-content-around 
                        position-relative TableRows align-items-center ${isCouple(i+1) ? "BgGrayTable" :"" }`}
                        key={i}
                    >
                        <h2 className="TableRowNumber">{i+1}</h2>
                        <div className="d-flex align-items-center">
                            <h3 className="TableRowName">{x.name}</h3>
                        </div>
                        <div className="d-flex align-items-center">
                            <h3 className="TableRowCeil">{x.UserCeiling}</h3>
                            <h3 className="TableRowName mr-1">ریال</h3>
                        </div>
                        <div className="d-flex align-items-center">
                            <h3 className="TableRowBalance">{x.UserBalance}</h3>
                            <h3 className="TableRowName mr-1">ریال</h3>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TodayRequest;